import React from 'react';
import { Field, useFormikContext } from 'formik';

import { AutoCompleteSelectUI, FormErrorUI, FormLabelUI, SelectUI } from '../Interface';
import { ItemKindList, ItemOwnershipTypeList } from '../../config/item';

const ItemAdditionalDataTab = ({ viewField, autocompleteOptions, selectedValues }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-2 gap-x-4 mx-4 mb-5">
      <div className="col-span-2 md:col-span-1">
        <Field
          name="kind"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Cikk jellege" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.kind} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('kind', value ?? null).then(() => {
              validateField('kind');
            });
          }}
          value={values.kind ?? ''}
          disabled={viewField}
          option={ItemKindList}
        />
      </div>
      <div className="col-span-2 md:col-span-1">
        <Field
          name="ownershipType"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Tulajdon típusa" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.ownershipType} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('ownershipType', value ?? null).then(() => {
              validateField('ownershipType');
            });
          }}
          value={values.ownershipType ?? ''}
          disabled={viewField}
          option={ItemOwnershipTypeList}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="defSupplier"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Alapértelmezett szállító" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defSupplier} />}
          onChange={(_e, newVal) => {
            setFieldValue('defSupplier', newVal?.value ?? null).then(() => {
              validateField('defSupplier');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defSupplier !== '' }}
          selectedValue={values.defSupplier}
          selectedLabelValue={selectedValues?.supplier?.name}
          dataset={autocompleteOptions?.supplier}
        />
      </div>
    </div>
  );
};

export default ItemAdditionalDataTab;
